export default __webpack_public_path__ + "static/media/fridge.ec96aceb.png";